import {createApp} from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'default-passive-events'
import * as THREE from 'three'
import 'animate.css';
import Lenis from '@studio-freight/lenis';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import './fonts/fonts.css';
import './style.css'
const app = createApp(App)
app.use(ElementPlus, {
    locale: zhCn,
})

app.config.globalProperties.$THREE = THREE
app.config.globalProperties.$router = router
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(store).use(router).mount('#app')